import { render, staticRenderFns } from "./ShowConfirm.vue?vue&type=template&id=71cf38d1"
import script from "./ShowConfirm.vue?vue&type=script&lang=js"
export * from "./ShowConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports